<script setup lang="ts">
import { formatNumberFullTruncate } from '@/helpers/utils'
import mineAntimineIcon from '@/assets/images/multiplayer/mine-antimine-icon.png'
import goldenCoinIcon from '@/assets/images/icons/gold-coin-icon.webp'
import { usePlayer } from '@/composables/game/player'
import BaseButton from '@/components/base/BaseButton.vue'

defineProps<{
  show: boolean
  goldenCoins: number
  sourceUserName: string
  sourceUserPhotoUrl?: string
}>()

const emit = defineEmits<{
  hide: []
}>()

const { goldenCoinValue } = usePlayer()
</script>

<template>
  <Transition
    name="fade"
    mode="out-in"
  >
    <div
      v-if="show"
      class="fixed h-screen max-h-dvh w-screen overflow-hidden left-0 bottom-0 bg-black/60 backdrop-blur-[12px] flex flex-col items-center justify-center z-[800] px-6"
    >
      <div class="w-full max-w-[400px] px-6 bg-black border-2 border-white/40 rounded-[32px] flex flex-col items-center">
        <div class="flex flex-col items-center p-6">
          <img
            :src="mineAntimineIcon"
            class="w-[120px] h-[120px] object-contain"
            alt="Anti-Mine"
          >

          <h2 class="font-pilat font-bold text-[24px] leading-8 text-white text-center">
            Yay! You have blocked a mine!
          </h2>

          <p class="text-white/60 text-base font-semibold text-center mb-3">
            This mine was placed on your card by:
          </p>

          <div class="flex flex-col items-center">
            <div
              v-if="sourceUserPhotoUrl"
              class="w-12 h-12 rounded-full overflow-hidden shrink-0"
            >
              <img
                :src="sourceUserPhotoUrl"
                :alt="sourceUserName"
                class="w-full h-full object-cover"
              >
            </div>
            <div
              v-else
              class="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center shrink-0 text-white font-bold text-lg"
            >
              {{ sourceUserName.charAt(0).toUpperCase() }}
            </div>
            <span class="text-white font-semibold text-base">{{ sourceUserName }}</span>
          </div>
        </div>
        <p class="text-white/60 text-base font-semibold text-center">
          You have received coins:
        </p>

        <div class="w-full flex flex-col items-center justify-center gap-2 bg-white/10 border border-white/20 rounded-[28px] px-4 py-3 mt-2">
          <img
            :src="goldenCoinIcon"
            class="w-auto h-[55px] object-contain shrink-0"
            alt="Golden coin"
          >
          <span class="coins-amount font-bold text-[28px] leading-[38px] drop-shadow-[0_0_8px_rgba(0,170,255,0.8)] -mt-6">
            +{{ formatNumberFullTruncate(goldenCoins*goldenCoinValue) }}
          </span>
        </div>

        <BaseButton
          class="w-full mt-6 mb-8"
          @click="emit('hide')"
        >
          GOT IT
        </BaseButton>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.coins-amount {
  color: #10F;
  text-align: center;
  text-shadow: 0 0 22.39px #10F;
  -webkit-text-stroke-width: 4px;
  -webkit-text-stroke-color: #36EEFF;
  paint-order: stroke fill;
}
</style>
